import { ReactNode } from 'react'

interface FormFieldProps {
  label: string
  children: ReactNode
  marginBottom?: string
  helpText?: string
}

export default function FormField({ 
  label, 
  children, 
  marginBottom = '1.5rem',
  helpText 
}: FormFieldProps) {
  return (
    <div style={{ marginBottom }}>
      <label style={{
        display: 'block',
        fontSize: '1rem',
        fontWeight: '600',
        color: 'var(--color-text)',
        marginBottom: '0.5rem'
      }}>
        {label}
      </label>
      {children}
      {helpText && (
        <div style={{
          fontSize: '0.875rem',
          color: 'var(--color-text-secondary)',
          marginTop: '0.5rem'
        }}>
          {helpText}
        </div>
      )}
    </div>
  )
}

